
import React from 'react';
import { 
  Monitor, 
  Smartphone, 
  FileText, 
  Camera, 
  PenTool, 
  ChevronRight, 
  Plus, 
  Trash2, 
  Settings, 
  Layout, 
  CheckCircle2, 
  ExternalLink,
  MessageSquare,
  ArrowRight,
  LogOut,
  Info,
  Users,
  Globe,
  Gamepad,
  PlayCircle,
  Zap,
  Database,
  Bot,
  Shield,
  X,
  Shirt,
  Scissors
} from 'lucide-react';

const icons = {
  Monitor,
  Smartphone,
  FileText,
  Camera,
  PenTool,
  ChevronRight,
  Plus,
  Trash2,
  Settings,
  Layout,
  CheckCircle2,
  ExternalLink,
  MessageSquare,
  ArrowRight,
  LogOut,
  Info,
  Users,
  Globe,
  Gamepad,
  PlayCircle,
  Zap,
  Database,
  Bot,
  Shield,
  X,
  Shirt,
  Scissors
};

export type IconName = keyof typeof icons;

interface IconProps {
  name: string;
  className?: string;
  size?: number;
}

export const Icon: React.FC<IconProps> = ({ name, className, size = 24 }) => {
  const LucideIcon = icons[name as IconName] || icons.Monitor;
  return <LucideIcon className={className} size={size} />;
};
